function Insights() {
  return (
    <section className="insights">
      <div className="wrap">
        <div className="section-head">
          <div className="eyebrow">Perspectives</div>
          <h2>Risk in focus.</h2>
          <p>Focused commentary on the trends shaping insurers, risk managers and reinsurance markets across Africa and beyond.</p>
        </div>
        <div className="insight-grid">
          <article className="insight">
            <div className="type">Market outlook</div>
            <h3>Building resilient reinsurance programmes in changing markets</h3>
            <p>Key considerations for aligning protection, retention and capital with business strategy.</p>
          </article>
          <article className="insight">
            <div className="type">Risk perspective</div>
            <h3>Managing natural catastrophe and climate exposures</h3>
            <p>How better exposure information can strengthen programme design and market engagement.</p>
          </article>
          <article className="insight">
            <div className="type">Africa focus</div>
            <h3>Supporting complex and emerging risks across Africa</h3>
            <p>The role of specialist capacity, local knowledge and international collaboration.</p>
          </article>
        </div>
      </div>
    </section>
  )
}

export default Insights
